<div class="share-member-list">
    <sync-dialog [config]="{
        title: 'Manage shared folder',
        subTitle: name,
        isClosable: true,
        onCloseIcon: closeDialog,
        cancelButton: 'Close',
        onCancelClick: closeDialog,
    }" [open]="showDialog" [isFullScreen]="isSMScreen">
    <div class="share-member-list-container">
        <ng-container *ngIf="loading">
            <sync-spinner></sync-spinner>
          </ng-container>
        <ng-container *ngIf="!loading">
            <ng-container>
                <div class="manage-share-buttons" *ngIf="shareData.isOwner">
                    <sync-button [label]="'Share settings'" [type]="'outlined'" [leadAdornment]="true"
                        [leadIconAdornment]="'folder-managed'" [onClick]="settings.bind(this)"></sync-button>
                    <sync-button [label]="'Change owner'" [type]="'outlined'" [leadAdornment]="true"
                        [leadIconAdornment]="'team-manage'" [onClick]="changeOwner"></sync-button>
                </div>
                <sync-divider *ngIf="shareData.isOwner" [text]="'Content'" [size]="'default'"></sync-divider>
                <div class="leave-section" *ngIf="!shareData.isOwner">
                    <sync-section-header class="leave-section-header" [header]="'Leave this shared folder'"
                        [level]="'subtitle'" [showActions]="true"
                        [showButton]="true"
                        [buttonConfig]="{label: 'Leave', type: 'outlined', color: 'critical', size:'small', leadAdornment:false, onClick: onLeave.bind(this)}">
                    </sync-section-header>
                </div>
                
                <sync-section-header *ngIf="listItems.length || shareData.isInvite" [header]="sharedWithHeader" [level]="'subtitle'" [showActions]="true" [showButton]="!!(shareData.isOwner || shareData.isInvite)" 
                        [buttonConfig]="sectionHeaderButtonConfig">
                </sync-section-header>

                <sync-list *ngIf="listItems.length"
                    [ListItems]="listItems"
                ></sync-list>
                <p class="body-2" *ngIf="!listItems.length">
                    No member names are viewable for this share.
                </p>
            </ng-container>
        </ng-container>
    </div>
</sync-dialog>

</div>